import React, {useMemo}  from 'react'
import { expandReference, deadlineObjectChecker } from '../../lib/utils';
import {ViewLabelValueField,VisDiv } from '../../components';
import {useStateContext} from '../../context/StateContext';

import {DataScadenza} from '../../lib/ScadenzeData'



/**
 * A component that displays the deadlines of a device.
 * It uses the DataScadenza function from ScadenzeData.js to retrieve the deadlines data.
 * The component renders a ViewLabelValueField for each deadline, with the label and value of the deadline.
 * If the deadline has expired, the value is highlighted with a red color.
 * #deadlines 
 * @param {Object} device - The device object.
 * @param {Object} deviceTemplate - The device template object.
 * @param {Object} registerTemplate - The register template object.
 */
const Scadenza = ({device, deviceTemplate, registerTemplate}) => {

    const {LDB} = useStateContext()
    const data = useMemo(() => (DataScadenza(device, deviceTemplate, registerTemplate)),[device,deviceTemplate, registerTemplate]);
    //console.log("edwdedwdwed", deadlineObjectChecker(expiry?.dateObject))
    const testing = false
    const {expiry, maintenanceTasksList} = data
    const label = () => {
        if(expiry?.label=="SCADENZA ESERCIZIO") return LDB("fields","assetExpiry")
        return expiry?.label
    }
    const exists = [!!expiry?.date].some?.(x=>x==true)
    const testFunction = () => {
        //console.log(DataScadenza(device, deviceTemplate, registerTemplate))
    }

        return (
            <div>
                <VisDiv rules={[testing]}><button onClick={()=>{testFunction()}}>Test deadlines</button></VisDiv>
                { expiry?.date &&
                <ViewLabelValueField
                    label={expiry.label}
                    value={ deadlineObjectChecker(expiry?.dateObject).date}
                    highlight={ deadlineObjectChecker(expiry?.dateObject).color}
                /> }

            </div>
        )
    

}

export default Scadenza
